import OptionsLabel from './OptionsLabel';

export default OptionsLabel;
